import type { HelpCenterArticleLinkProps } from "./help-center-article-link.type";

import { ExportOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import { useAppLocale } from "@/services/language";

import { HELP_CENTER_LINKS } from "../help-center.constant";

const GAP = 5;

const HelpCenterArticleLink = ({
  type,
  showInfoIcon,
  showBlankIcon,
}: HelpCenterArticleLinkProps) => {
  const { t } = useTranslation();
  const locale = useAppLocale();

  return (
    <Flex gap={GAP}>
      {showInfoIcon && <InfoCircleOutlined />}
      <a
        href={HELP_CENTER_LINKS[type][locale]}
        target="_blank"
        rel="noreferrer"
      >
        {t("global:helpCenter.articleLink")}
        {showBlankIcon && <ExportOutlined style={{ marginLeft: GAP }} />}
      </a>
    </Flex>
  );
};

export default HelpCenterArticleLink;
